// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__ippFS","colMin":"styles_colMin__3Mqix","colCheckbox":"styles_colCheckbox__eZ-65"};